import Axios, { AxiosRequestConfig } from 'axios';

import { API_CONFIG } from '@/config';
import { storage } from '@/utils';

function authRequestInterceptor(config: AxiosRequestConfig) {
    const token = storage.getToken();
    if (token) {
        config.headers.authorization = `Bearer ${token}`;
    }
    config.headers.Accept = 'application/json';
    return config;
}

export const axios = Axios.create({
    baseURL: `${API_CONFIG.API_URL}/api`
});

axios.interceptors.request.use(authRequestInterceptor);
axios.interceptors.response.use(
    (response) => {
        return response.data;
    },
    (error) => {
        const message = selectErrorKeyOrMessage(error);
        const status = selectErrorCode(error);
        return Promise.reject({ message, status });
    }
);

const selectErrorKeyOrMessage = (error: any) => {
    if (error && error.response && error.response.data) {
        const data = error.response.data;

        if (data.error && data.error.message) {
            return data.error.message;
        }

        return String(data);
    }

    return error.message || 'An error occurred, please try again';
};

export const selectErrorCode = (error: any) => {
    if (error && error.response && error.response.status) {
        return error.response.status;
    }
    return 500;
};
